// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__Xg6VN","closeModalIcon":"PopUpModal_closeModalIcon__g0qbY"};